module.exports = __webpack_public_path__ + "static/bedroom-d6d65e6dfee3b9cc6cc8fe2238d4554a.jpg";